module.exports = __webpack_public_path__ + "static/media/users.400fbd5a.svg";